import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@knockrentals/knock-shared-web-v2';
import { PROPERTIES_DIALOG_MODES } from '../constants';

const HeaderActions = ({ isTransferPropertyDisabled, setMode }) => {
  return (
    <div>
      <Button
        onClick={setMode(PROPERTIES_DIALOG_MODES.IMPORT)}
        startIcon={<Icon name="file-table" size={20} />}
        variant="text"
      >
        Import Properties
      </Button>

      <Button
        disabled={isTransferPropertyDisabled}
        onClick={setMode(PROPERTIES_DIALOG_MODES.TRANSFER)}
        startIcon={<Icon name="move" size={20} />}
        variant="text"
      >
        Transfer Property
      </Button>

      <Button
        onClick={setMode(PROPERTIES_DIALOG_MODES.CREATE)}
        startIcon={<Icon name="add-lg" size={20} />}
      >
        New Property
      </Button>
    </div>
  );
};

HeaderActions.propTypes = {
  isTransferPropertyDisabled: PropTypes.bool,
  setMode: PropTypes.func,
};

export default HeaderActions;
